// layouts/Homepage.js

import React from 'react';
import Banner from '../components/Banner';
import About from '../components/About';
import Projects from '../components/Projects';
import Work from '../components/Work';
import Contact from '../components/Contact';

function Homepage() {
  return (
    <div>
      <Banner />
      <About />
      <Projects />
      <Work />
      <Contact />
    </div>
  );
}

export default Homepage;
